import { useDispatch, useSelector } from "../hooks.js";
import { setAuthChecked, setAuthed } from "../features/account/accountSlice.js";
import Cookies from "js-cookie";

export default function useAuth() {
    const dispatch = useDispatch();
    const { authChecked, isAuthed } = useSelector((state) => state.account);

    const checkAuth = () => {
        if (Cookies.get("cs_infoviewer_auth")) {
            dispatch(setAuthed(true));
        }
        dispatch(setAuthChecked(true));
    };

    return { checkAuth, isAuthed, authChecked };
}
